export function getStrapiMedia(url?: string) {
  if (url == null) {
    return ''
  }

  // S3 provider OR Local Next.js static asset
  if (url.startsWith('http') || url.startsWith('/_next/')) {
    return url
  }

  return `${
    process.env.NEXT_PUBLIC_STRAPI_API_URL ?? 'http://localhost:1337'
  }${url}`
}
